import moment from 'moment';
export default {
  methods: {
    currencyFormat(value, currency = 'MXP') {
      if(value || value === 0){
        switch (currency) {
          case 'MXP':
          case 'MXN':
            return '$' + parseFloat(value).toLocaleString('mx-MX', {minimumFractionDigits: 2, maximumFractionDigits: 2}) + ' MXP';
          case 'USD':
            return '$' + parseFloat(value).toLocaleString('mx-MX', {minimumFractionDigits: 2, maximumFractionDigits: 2}) + ' USD';
          case 'EUR':
            return '€' + parseFloat(value).toLocaleString('mx-MX', {minimumFractionDigits: 2, maximumFractionDigits: 2}) + ' EUR';
          default:
            break;
        }
      }
    },
    numberFormat(value, decimals) {
      if(value || value === 0){
        if(decimals){
          return parseFloat(value).toLocaleString('mx-MX', {minimumFractionDigits: decimals, maximumFractionDigits: decimals});
        } else {
          return parseFloat(value).toLocaleString();
          
        }
      }
    },
    percentageFormat(params) {
      if(params || params === 0){
        return (params * 100) + '%';
      }
    },
		dateFormat(params, format) {
      if(params){
        return moment(params).format(format || "YYYY-MM-DD");
      }
    },
  }
}